import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import FeatureComparison from './components/FeatureComparison';
import ProductCategories from './components/ProductCategories';
import PillarArticles from './components/PillarArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <FeatureComparison />
        <ProductCategories />
        <PillarArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}